import { formatPrice } from '../formats';
import { getNonCharityTicketsForRace } from '../ticket';

/**
 * Returns an object describing ticket prices, of "available" tickets, given a races array.
 */
export default (races = []) => {
  const availabilePrices = []
    .concat(...races.map(getNonCharityTicketsForRace))
    .filter((t) => t.charityTickets !== true)
    .map((t) => t.discountPrice || t.rrp);

  // Assumed to always be identical
  const currencyLabel =
    races.map((r) => r?.tickets?.currencyLabel).find((i) => i) || '';

  if (availabilePrices.length > 0) {
    const multiplePrices = [...new Set(availabilePrices)].length > 1;
    const pricesFrom = Math.min(...availabilePrices);
    const pricesTo = Math.max(...availabilePrices);

    return {
      fromFormatted: formatPrice(currencyLabel, pricesFrom),
      ...(multiplePrices && {
        toFormatted: formatPrice(currencyLabel, pricesTo),
      }),
    };
  }

  return null;
};
